export const promotionFixedPriceRoutesVJ: any = {
  "SGNDLI": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "DLISGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "SGNPQC": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "PQCSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "SGNBMV": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "BMVSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "SGNPXU": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "PXUSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "SGNCXR": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "CXRSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "SGNTBB": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "TBBSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,
  "VDHHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 1495000,

  "SGNDAD": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "DADSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "SGNHUI": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "HUISGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "SGNVCL": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "VCLSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "SGNUIH": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "UIHSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "SGNVDH": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "VDHSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "HANDAD": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "DADHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "HANHUI": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "HUIHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "HANPXU": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2100000,
  "PXUHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2100000,
  "HANUIH": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2100000,
  "UIHHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2100000,
  "HANDLI": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2100000,
  "DLIHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2100000,
  "HANBMV": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2100000,
  "BMVHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2100000,
  "HANCXR": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2100000,
  "CXRHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2100000,
  "HPHBMV": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "BMVHPH": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "HPHDLI": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "DLIHPH": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "HPHDAD": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "DADHPH": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "HPHCXR": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "CXRHPH": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "VIIBMV": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "BMVVII": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "VIIDLI": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "DLIVII": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "THDDLI": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "DLITHD": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "DADVCA": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "VCADAD": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "DADPQC": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "PQCDAD": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "DADCXR": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,
  "CXRDAD": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2100000,

  "SGNVII": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2320000,
  "VIISGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2320000,
  "SGNHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2320000,
  "HANSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2320000,
  "SGNPHP": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2320000,
  "PHPSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2320000,
  "SGNTHD": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2320000,
  "THDSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === 'QH' ? 700 : 2320000,

  "HANVCA": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2650000,
  "HANPQC": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2650000,
  "VCAHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2650000,
  "PQCHAN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2650000,
  "HPHPQC": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2650000,
  "PQCHPH": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2650000,
  "HPHVCA": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2650000,
  "VCAHPH": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2650000,
  "SGNVDO": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2650000,
  "VDOSGN": process.env.NEXT_PUBLIC_PROMOTION_CODE === "QH" ? 700 : 2650000,
}

export const promotionFixedDiscountRoutesVJ: any = {
  "SGNDLI": 150000,
  "DLISGN": 150000,
  "SGNPQC": 150000,
  "PQCSGN": 150000,
  "SGNBMV": 150000,
  "BMVSGN": 150000,
  "SGNPXU": 150000,
  "PXUSGN": 150000,
  "SGNCXR": 150000,
  "CXRSGN": 150000,
  "SGNTBB": 150000,
  "TBBSGN": 150000,
  "VDHHAN": 150000,

  "SGNDAD": 200000,
  "DADSGN": 200000,
  "SGNHUI": 200000,
  "HUISGN": 200000,
  "SGNVCL": 200000,
  "VCLSGN": 200000,
  "SGNUIH": 200000,
  "UIHSGN": 200000,
  "SGNVDH": 200000,
  "VDHSGN": 200000,
  "HANDAD": 200000,
  "DADHAN": 200000,
  "HANHUI": 200000,
  "HUIHAN": 200000,
  "HANPXU": 200000,
  "PXUHAN": 200000,
  "HANUIH": 200000,
  "UIHHAN": 200000,
  "HANDLI": 200000,
  "DLIHAN": 200000,
  "HANBMV": 200000,
  "BMVHAN": 200000,
  "HANCXR": 200000,
  "CXRHAN": 200000,
  "HPHBMV": 200000,
  "BMVHPH": 200000,
  "HPHDLI": 200000,
  "DLIHPH": 200000,
  "HPHDAD": 200000,
  "DADHPH": 200000,
  "HPHCXR": 200000,
  "CXRHPH": 200000,
  "VIIBMV": 200000,
  "BMVVII": 200000,
  "VIIDLI": 200000,
  "DLIVII": 200000,
  "THDDLI": 200000,
  "DLITHD": 200000,
  "DADVCA": 200000,
  "VCADAD": 200000,
  "DADPQC": 200000,
  "PQCDAD": 200000,
  "DADCXR": 200000,
  "CXRDAD": 200000,

  "SGNVII": 200000,
  "VIISGN": 200000,
  "SGNHAN": 200000,
  "HANSGN": 200000,
  "SGNPHP": 200000,
  "PHPSGN": 200000,
  "SGNTHD": 200000,
  "THDSGN": 200000,

  "HANVCA": 300000,
  "HANPQC": 300000,
  "VCAHAN": 300000,
  "PQCHAN": 300000,
  "HPHPQC": 300000,
  "PQCHPH": 300000,
  "HPHVCA": 200000,
  "VCAHPH": 200000,
  "SGNVDO": 300000,
  "VDOSGN": 300000,
}

export const notIsDomesticRoutesPomotionVJ = [
  "SGNRMQ",
  "RMQSGN",
  "SGNICN",
  "ICNSGN",
  "SGNKIX",
  "KIXSGN",
  "SGNNRT",
  "NRTSGN",
  "HANRMQ",
  "RMQHAN",
  "HANICN",
  "ICNHAN",
  "HANKIX",
  "KIXHAN",
  "HANNRT",
  "NRTHAN",
]

export const routesPromotionSUN: any = {
  SGNHAN: {
    promotion: "promotion9G.1"
  },
  PQCHAN: {
    promotion: "promotion9G.1"
  },
  DADHAN: {
    promotion: "promotion9G.1"
  },

  SGNPQC: {
    promotion: "promotion9G.2"
  },
  HANPQC: {
    promotion: "promotion9G.2"
  },
  DADPQC: {
    promotion: "promotion9G.2"
  },

  HANSGN: {
    promotion: "promotion9G.3"
  },
  PQCSGN: {
    promotion: "promotion9G.3"
  },
  DADSGN: {
    promotion: "promotion9G.3"
  },
}
